import {Spot, Point, TextBlock, GraphObject, InputEvent} from 'gojs';

import {DASHBOARD_PATH} from 'src/routes';
import {colorSecondaryBlue, colorSecondaryBlueValues} from 'src/styles/colors';
import {MakeFnInitializers} from 'src/util/gojs/types';
import {promptFont} from 'src/util/gojs/styles/fonts';
import {processRest} from 'src/util/gojs/utils';

const CLICK_EVENTS = [
  'BackgroundSingleClicked',
  'BackgroundContextClicked',
  'ObjectSingleClicked',
  'ObjectContextClicked',
] as const;

const {make} = GraphObject;

const LINK_COLOR = colorSecondaryBlue;
const LINK_HOVER_COLOR = `rgba(${colorSecondaryBlueValues.join(',')}, 0.8)`;

const adornment = make('ContextMenu', // that has one button
    make('ContextMenuButton',
        {
          'ButtonBorder.fill': 'white',
          '_buttonFillOver': 'skyblue',
          'alignment': Spot.Left, 'alignmentFocus': Spot.Right,
        },
        make(TextBlock, 'Open Link in new Tab'),
        {
          click: (_e, obj) => {
            const appName = obj.part?.data.data.name;
            window.open(`${DASHBOARD_PATH}?application=${appName}`, '_blank');
          },
        }),

);

export const link = (rest?: MakeFnInitializers) =>
  make(
      TextBlock,
      {
        cursor: 'pointer',
        font: promptFont(1),
        editable: false,
        stroke: LINK_COLOR,
        // See: https://forum.nwoods.com/t/how-to-prevent-select-action-on-a-click/5312
        isActionable: true,
        click: ({diagram: {lastInput: {shift}}}: InputEvent, obj: GraphObject) => {
          const appName = obj.part?.data.data.name;

          if (shift) {
            window.open(`${DASHBOARD_PATH}?application=${appName}`, '_blank');
            return;
          }

          const model = obj.diagram?.model;
          if (!model) {
            return;
          }
          const navigate = model.modelData.navigate;
          navigate(`${DASHBOARD_PATH}?application=${appName}`);
        },
        contextClick: (_e: InputEvent, obj: GraphObject) => {
          const part = obj.part;
          const diagram = obj.diagram;
          if (!diagram) {
            return;
          }
          adornment.adornedObject = part;
          if (!part) {
            return;
          }
          const mousePt = diagram.lastInput.viewPoint;
          adornment.position = diagram.transformViewToDoc(new Point(mousePt.x, mousePt.y));
          part.addAdornment('contextClick', adornment);

          const handle = () => {
            part.removeAdornment('contextClick');
            CLICK_EVENTS.forEach((eventName) => {
              diagram.removeDiagramListener(eventName, handle);
            });
          };

          CLICK_EVENTS.forEach((eventName) => {
            diagram.addDiagramListener(eventName, handle);
          });
        },
        mouseEnter: (_e:InputEvent, obj: GraphObject) => {
          if (obj instanceof TextBlock) {
            obj.stroke = LINK_HOVER_COLOR;
            obj.isUnderline = true;
          }
        },
        mouseLeave: (_e:InputEvent, obj: GraphObject) => {
          if (obj instanceof TextBlock) {
            obj.stroke = LINK_COLOR;
            obj.isUnderline = false;
          }
        },
      },
      processRest(rest),
  );
